// src/modules/bookLocation/keyHandover/steps/SubscriptionChoiceStep.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { useSubscriptionChoice } from "../context/SubscriptionChoiceContext";

const SubscriptionChoiceStep = () => {
    const { t } = useTranslation();
    const { hasExistingSubscription, selectExisting, selectNew } = useSubscriptionChoice();

    return (
        <div className="flex flex-col gap-4">
            {/* Choice Cards */}
            <div className="flex flex-col gap-4">
                {/* YES - I have a subscription */}
                <button
                    onClick={selectExisting}
                    className={`
            relative p-6 border rounded-lg transition-all
            hover:border-primary hover:shadow-md
            ${
                hasExistingSubscription === "existing"
                    ? "border-primary bg-primary/5 shadow-md"
                    : "border-slate-200 bg-white"
            }
          `}
                >
                    {hasExistingSubscription === "existing" && (
                        <div className="absolute top-1/2 -translate-y-1/2 right-3">
                            <div className="bg-primary text-white rounded-full p-1">
                                <Check className="h-4 w-4" />
                            </div>
                        </div>
                    )}

                    <div className="text-left">
                        <div className="text-lg font-semibold text-slate-900">
                            {t("book_location.keys.subscription_choice.yes_title")}
                        </div>
                    </div>
                </button>

                {/* NO - Create new subscription */}
                <button
                    onClick={selectNew}
                    className={`
            relative p-6 border rounded-lg transition-all
            hover:border-primary hover:shadow-md
            ${
                hasExistingSubscription === "new"
                    ? "border-primary bg-primary/5 shadow-md"
                    : "border-slate-200 bg-white"
            }
          `}
                >
                    {hasExistingSubscription === "new" && (
                        <div className="absolute top-1/2 -translate-y-1/2 right-3">
                            <div className="bg-primary text-white rounded-full p-1">
                                <Check className="h-4 w-4" />
                            </div>
                        </div>
                    )}

                    <div className="text-left">
                        <div className="text-lg font-semibold text-slate-900">
                            {t("book_location.keys.subscription_choice.no_title")}
                        </div>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default SubscriptionChoiceStep;
